import { Button, SxProps } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface Props {
  text: string;
  btnSx?: SxProps;
  asan?: boolean;
  cancel?: () => void;
  tab?: number;
}
const BackButton = (props: Props) => {
  const { text, btnSx, asan, cancel } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  const goBack = () => {
    if (asan) {
      cancel();
      navigate(`${lang}/login`, { state: { tab: 1 } });
    } else {
      navigate(`${lang}/login`, { state: { tab: 0 } });
    }
  };

  return (
    <Button sx={btnSx} type={'button'} variant={'text'} onClick={goBack}>
      {t(text)}
    </Button>
  );
};

export default BackButton;
